/* istanbul ignore file */
import { PaymentMethod, PaymentStatus } from "../../graphql/supergraph.index";
import { MoneyType } from "../Money";

export type PositionRowItem = {
  id: string;
  payee: string | undefined;
  paymentInstructions: string | null | undefined;
  method: string | null | undefined;
  amount: MoneyType | undefined;
  hostName: string | undefined;
  accountId: string | undefined;
  status: PaymentStatus;
};

type Arena = {
  jsqHostname: string;
  id: string;
};

type Account = {
  id: string;
  name: string;
  arena: Arena | null;
};

type Position = {
  id: string;
  account: Account | null;
};

type PositionNode = {
  id: string;
  position: Position | null;
};

export type DistributionEdge = {
  node: PositionNode;
};

export type Payments = {
  objectId: string;
  status: PaymentStatus;
  method: PaymentMethod;
  amount: MoneyType;
};

export type PositionProps = {
  id: string;
  batchId: string | undefined;
  hostName: string;
  payments: Payments[];
  batchLabel: string;
};

export enum PositionStatusIcons {
  PROCESSING = "sync-alt",
  SETTLED = "check",
  FAILED = "exclamation-circle",
  PENDING = "hourglass-start",
  CANCELED = "times-circle",
}
export enum PositionStatusText {
  PROCESSING = "Processing",
  SETTLED = "Settled",
  FAILED = "Failed",
  PENDING = "Pending",
  CANCELED = "Canceled",
}
